import React, { useEffect } from "react";
import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import styles from "./signInAs.module.scss";
import AuthService from "src/utils/auth.service";
import userRoleService from "src/utils/userRoles.service";

export default function SignInAs() {

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location && location.search) {
      let at = new URLSearchParams(location.search).get('at');
      let rt = new URLSearchParams(location.search).get('rt');

      if (at && rt) {
        AuthService.saveToken(at, rt);
        if(AuthService.isAuthenticated()) {
          navigate(userRoleService.getHomePagePath());
        }
      }
    }
  }, [location, navigate]);

  return (
    <div className={styles.loaderContainer}>
      <p>Loading Application...</p>
    </div>
  )
}